export const SET_ROLLO_DELIVERY_AVAILABILITY = 'Rollo/SET_ROLLO_DELIVERY_AVAILABILITY';

export const setRolloDeliveryAvailability = (payload) => ({
  type: SET_ROLLO_DELIVERY_AVAILABILITY,
  payload,
});
